export * from './delete-popup.module';
export * from './delete-popup.component';
